import { render } from "./SidebarComponent.vue?vue&type=template&id=41fbe18d&scoped=true&ts=true"
import script from "./SidebarComponent.vue?vue&type=script&lang=ts"
export * from "./SidebarComponent.vue?vue&type=script&lang=ts"

import "./SidebarComponent.vue?vue&type=style&index=0&id=41fbe18d&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41fbe18d"]])

export default __exports__